/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v2.7.1 of "Payments service"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */

/**
 * Structure containing data related to the client-generated public key.
 */
export type EllipticCurvePublicKey = {
    /**
     * Identification of the elliptic curve which was used when generating the key pair.
     *
     */
    crv: EllipticCurvePublicKey.crv;
    /**
     * Type of the asymmetric key that is provided by the client.
     *
     */
    kty: EllipticCurvePublicKey.kty;
    /**
     * First part of the public key generated by the client.
     */
    'x': string;
    /**
     * Second part of the public key generated by the client.
     */
    'y': string;
    /**
     * Unique ID of they client-generated key-pair.
     *
     */
    kid: string;
};

export namespace EllipticCurvePublicKey {

    /**
     * Identification of the elliptic curve which was used when generating the key pair.
     *
     */
    export enum crv {
        P_256 = 'P_256',
        P_521 = 'P_521',
    }

    /**
     * Type of the asymmetric key that is provided by the client.
     *
     */
    export enum kty {
        EC = 'EC',
    }


}

